import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './authorize.service';

/**
 * Lässt nur Rollen mit Stammkunden-Zugang in den Stammkunden-Bereich
 * (SuperAdmin, Admin, Kaufmännisch, ProjektleiterKaufmann, Bauleiter, Vorarbeiter).
 * Die eigentliche Datensichtbarkeit wird serverseitig pro Kunde gescopt.
 */
@Injectable({
  providedIn: 'root'
})
export class StammkundenGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isAuthenticated() && this.authService.canAccessStammkunden()) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
